import { useMemo } from "react";

// Components
import useTranslate from "hooks/useTranslate";
import { useSelector } from "react-redux";
import * as userSelectors from "redux/user/selectors";
import useFormatBonusBalance from "hooks/useFormatBonusBalance";
import Timer from "../Timer";
import WelcomeBonusCardItem from "../../molecules/WelcomeBonusCardItem";

// Selectors

// Hooks
import useFormatNumber from "../../../hooks/useFormatNumber";

// Types
import { BonusItem, BonusListType } from "../../../types/Bonus";

import "./styles.sass";

type DescriptionRewardProps = {
  bonus: BonusListType;
};

const DescriptionReward = (props: DescriptionRewardProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { bonus } = props;
  const t = useTranslate();
  const currency = useSelector(userSelectors.currency);
  const formatNumber = useFormatNumber();
  const formatBalance = useFormatBonusBalance();
  const bonusReward =
    "reward" in bonus &&
    bonus.reward &&
    `${currency?.sign} ${formatBalance(bonus.reward)}`;
  const currentWager =
    "wager" in bonus && bonus.wager && formatNumber(bonus.wager, 0, true);

  const expiredDate = useMemo(() => {
    if ("expireDate" in bonus) {
      return bonus.expireDate;
    }
    if ("expireAt" in bonus) {
      return bonus.expireAt;
    }
    return "";
  }, [bonus]);

  const BONUS_DEPOSIT_LIST_ITEM: BonusItem[] = [
    { id: 1, name: "bonus.back.amount", value: `${bonusReward}` },
    { id: 2, name: "bonus.back.category.spins", value: "Slots" },
    { id: 3, name: "bonus.back.wager", value: "x50" },
    { id: 4, name: "bonus.back.amount.slots", value: `${currentWager}` },
  ];
  return (
    <div className="DescriptionReward">
      <div className="DescriptionReward-block">
        <span className="DescriptionReward-block__title">
          {t("bonus.info.valid")}
        </span>
        <Timer finishDate={expiredDate} isBonus />
      </div>
      <div className="DescriptionReward__list">
        {BONUS_DEPOSIT_LIST_ITEM.map((item) => (
          <WelcomeBonusCardItem key={item.id} bonus={item} />
        ))}
      </div>
    </div>
  );
};

export default DescriptionReward;
